// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { searchFacetsRenderFunction } from 'js/searchFacetsService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/searchFacetsService', () => import('js/searchFacetsService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "imports": [],
  "actions": {
    "render": {
      "method": "searchFacetsRenderFunction",
      "deps": "js/searchFacetsService"
    },
    "updateFacets": {
      "actionType": "JSFunction",
      "method": "updateFacets",
      "inputData": {
        "data": "{{data}}",
        "updatedFacets": "{{parameters.updatedFacets}}"
      },
      "deps": "js/searchFacetsService"
    },
    "searchFacetsOnMount": {
      "actionType": "JSFunction",
      "method": "searchFacetsOnMountFunction",
      "deps": "js/searchFacetsService"
    }
  },
  "data": {
    "facets": [],
    "query": "",
    "sections": [],
    "showLessMoreMap": {}
  },
  "dataParseDefinitions": {},
  "dataProviders": {},
  "columnProviders": {},
  "grids": {},
  "i18n": {
    "apply": ["projectMessages"],
    "clearAll": ["projectMessages"],
    "lastModifiedBy": ["projectMessages"],
    "myHome": ["projectMessages"],
    "owner": ["projectMessages"],
    "category": ["projectMessages"],
    "container": ["projectMessages"],
    "createdBy": ["projectMessages"],
    "folder": ["projectMessages"],
    "typeName": ["projectMessages"],
    "showMore": ["projectMessages"],
    "showLess": ["projectMessages"]
  },
  "lifecycleHooks": {
    "render": "render",
    "onMount": "searchFacetsOnMount"
  },
  "onEvent": [{
    "eventId": "updateFacets",
    "action": "updateFacets",
    "inputArgs": {
      "updatedFacets": "{{eventData}}"
    }
  }],
  "props": {},
  "conditions": {},
  "_viewModelId": "SearchFacets",
  "_uniqueViewModelId": "SearchFacets",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, searchFacetsRenderFunction, undefined, ctxImportObj);
export default Component;